import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import NSFHistoryTable from "../../components/NSF/NSFHistoryTable";
import NSFHistoryModal from "../../components/NSF/NSFHistoryModal";
import LoadingSpinner from "../../components/Spinner";
import styles from "./Nsf.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchNsfHistory } from "../../store/reducers/nsfSlice/api";

const NSFHistory = () => {
  const dispatch = useDispatch();
  const { data: historyData, status: historyStatus } = useSelector(
    (state) => state.nsf.nsfHistory
  );
  const accounts = useSelector((state) => state.account.accountOptions)
    .map((data) => data.value)
    .join(" ");

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);
  const [historyItems, setHistoryItems] = useState([]);

  useEffect(() => {
    if (historyData === null && accounts) {
      dispatch(fetchNsfHistory({ accounts }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, dispatch]);

  const handleShowHistory = (nsfCase) => {
    if (nsfCase) {
      setSelectedCase(nsfCase);
      const items = historyData?.grouped?.[nsfCase?.LoanRecID] || [];
      setHistoryItems(items);
    }
    setShowHistoryModal(true);
  };

  const handleCloseHistory = () => {
    setShowHistoryModal(false);
    setHistoryItems([]);
    setSelectedCase(null);
  };

  return (
    <div className={`${styles.pageContainer} ${styles.nsfComponent}`}>
      <section className={`rounded container-fluid ${styles.sectionContainer}`}>
        <Container className={`p-4 ${styles.contentContainer}`}>
          <Row className="align-items-center mb-4">
            <Col md={12}>
              <h1 className={styles.nsfPageTitle}>NSF Borrower History</h1>
              <p className={styles.nsfPageDescription}>
                Complete history of all non-sufficient funds cases.
                View detailed records of NSF occurrences, amounts, and payment statuses.
              </p>
            </Col>
          </Row>

          {historyStatus === "loading" && (
            <div className="py-5">
              <LoadingSpinner />
            </div>
          )}

          {historyStatus === "fulfilled" && Array.isArray(historyData?.cases) && (
            <NSFHistoryTable
              cases={historyData.cases}
              onShowHistory={handleShowHistory}
            />
          )}

          {historyStatus === "failed" && (
            <div className="text-center py-5">
              <p className="text-danger">Failed to load NSF history. Please try again.</p>
            </div>
          )}
        </Container>
      </section>

      <NSFHistoryModal
        show={showHistoryModal}
        onHide={handleCloseHistory}
        items={historyItems}
        title={
          selectedCase ? `NSF History - ${selectedCase.borrower}` : "History"
        }
        caseData={selectedCase}
      />
    </div>
  );
};

export default NSFHistory;
